import PropTypes from 'prop-types';
import React from 'react';
import colors from '@loggi/ui/components/utils/colors';
import styles from './styles.scss';

const rectProps = props => ({
  x: 1,
  y: 1,
  rx: 2,
  ry: 2,
  height: 18,
  width: 18,
  'data-checked': props.checked,
  'data-disabled': props.disabled,
  style: {
    stroke: props.checked ? colors.hex.active : colors.hex.light,
    'stroke-width': 2
  }
});

function CheckboxShape(props) {
  const { color } = props;

  return (
    <svg height="20" width="20" className={styles.svg} data-fill={color}>
      <rect className={styles.outerElement} {...rectProps(props)} />
      <rect className={styles.innerElement} {...rectProps(props)} />
    </svg>
  );
}

CheckboxShape.displayName = 'CheckboxShape';
CheckboxShape.propTypes = {
  size: PropTypes.string,
  disabled: PropTypes.bool,
  checked: PropTypes.bool,
  color: PropTypes.string
};
CheckboxShape.defaultProps = {
  size: 'regular',
  disabled: false,
  checked: false,
  color: 'active'
};

export default CheckboxShape;
